export const buildNdcFlowKey = (pageName: string, fullUrl: string): string =>
  `${pageName}|${fullUrl}`;

export const isDuplicateNdcFlow = (
  key: string,
  lastKey: string | null | undefined
): boolean => key === lastKey;
